import React from "react";
import './HotelSkeleton.css'
import { Container, Row, Col, Card } from "react-bootstrap";
const HotelSkeleton = () => {
  return (
    <div className="container_loader2" id="Loader">
      <div className="loader-wrapper loader-hide">
        <div className="row loader-img">
          <div className="col-12">
            <img
              src="/Images/hotel_loader.gif"
              alt="loader"
              className="img-fluid"
            />
        <p style={{color:'#fff'}}>
           Pillows fluffed! Finding your dream hotel now.
        </p>
          </div>
          <div>
             
          </div>
        </div>
      </div>
    </div>
  );
};

export default HotelSkeleton;
